import ApiService from '../service/ApiService';

let moduleApi = {};
let moduleName = "doi_tuong_cach_ly";

moduleApi.create = (dataForm) => {
  let api = {
    module: moduleName,
    type: "create",
    value: dataForm
  };
  return ApiService(api);
};

moduleApi.update = (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm
  };
  return ApiService(api);
};

moduleApi.list = (dataFilter) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter
  };
  return ApiService(api);
};

moduleApi.delete = (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: { id: id }
  };
  return ApiService(api);
};

moduleApi.findById = (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: { id: id }
  };
  return ApiService(api);
};

moduleApi.get_many = (provice,limit) => {
  let api = {
    module: moduleName,
    type: "get_many",
    params: {
      "co_so_cach_ly.ma_tinh": provice,
      "$limit":limit,
    },
    message: {
      success: "",
      error: "",
    },
  };
  return ApiService(api);
};
moduleApi.listBenhVien = (dataFilter) => {
  let api = {
    module: moduleName,
    type: "get_hospital",
    value: dataFilter
  };
  return ApiService(api);
};

moduleApi.listLoaiKham = (dataFilter) => {
  let api = {
    module: moduleName,
    type: "get_patient_type",
    value: dataFilter
  };
  return ApiService(api);
};

moduleApi.listPhongKham = (dataFilter) => {
  let api = {
    module: moduleName,
    type: "get_room",
    value: dataFilter
  };
  return ApiService(api);
};

moduleApi.listDichVu = (dataFilter) => {
  let api = {
    module: moduleName,
    type: "get_service",
    value: dataFilter
  };
  return ApiService(api);
};

export default moduleApi;
